module.exports = __webpack_public_path__ + "static/media/tracking.2f8e0f9a.svg";